import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ContentPagesService } from '@shared/cms/services';
import { ContentPage } from '@shared/cms/models';
import { ModalService } from '@core/services';

@Component({
  selector: 'app-apply-for-support-modal',
  templateUrl: './apply-for-support-modal.component.html',
  styleUrls: ['./apply-for-support-modal.component.less'],
  encapsulation: ViewEncapsulation.None,
})
export class ApplyForSupportModalComponent implements OnInit {

  public contentBlocks: any;

  constructor(private contentPageService: ContentPagesService,
    private modalService: ModalService) { }

  ngOnInit() {
    const result = [];
    this.contentPageService.getContentPageBySlug('community-landing').subscribe(
      (val: ContentPage) => {
        val[0].contentBlocks.map((cb) => result[(cb.slug as string).replace(/-/g, '')] = {content: cb.content, isHtml: cb.isHTML});
        this.contentBlocks = result;
      }, err => {
        console.log(err);
    });
  }

  close(): void {
    this.modalService.hideModal();
  }

}
